/**
 * @file Barre du bas du hub social : Ranger l'arme, Feu d'artifice, FX on/off, Boutique skins. Visible uniquement avec le preset 'hub'.
 */
import { Component } from '../core/Component';
import { h, setText, toggleClass } from '../core/dom';
import { uiIcon } from '../core/uiIcons';
import type { UiIconId } from '../core/uiIcons';
import { openScreen, send } from '../core/feedback';
import type { UiContext } from '../UiContext';
import { fxAnyVisible, toggleAllFx } from './fxVisibility';

interface BarButton {
  root: HTMLElement;
  label: HTMLElement;
}

const button = (cls: string, icon: UiIconId, onclick: () => void): BarButton => {
  const label = h('span', { class: 'hub-btn-label' });
  const root = h('button', { class: `hub-btn ${cls}`, type: 'button', 'data-ui-block': true, 'data-fast': true, onclick }, h('span', { class: 'hub-btn-icon' }, uiIcon(icon)), label);
  return { root, label };
};

export class HubBar extends Component {
  private stow!: BarButton;
  private fx!: BarButton;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'hub-bar');
  }

  protected build(): void {
    const ctx = this.ctx;
    this.stow = button('hub-stow', 'gun', () => void send(ctx, { type: 'hub.stow' }));
    const fire = button('hub-firework', 'firework', () => void send(ctx, { type: 'hub.firework' }));
    this.fx = button('hub-fx', 'sparkle', () => {
      // Masque / reaffiche TOUS les effets cosmetiques (les miens et ceux des autres joueurs) ; reglage fin dans Reglages.
      const next = toggleAllFx(ctx.sim.data.settings);
      void send(ctx, { type: 'settings.set', patch: next });
      // tout reafficher rallume aussi mon aura si je l'avais coupee (elle redevient visible pour les autres)
      const a = ctx.sim.data.auras;
      if (next.fxSelf && a.equipped !== null && !a.enabled) void send(ctx, { type: 'aura.toggle', enabled: true });
    });
    const shop = button('hub-shop', 'bag', () => openScreen('hubshop'));
    setText(fire.label, ctx.i18n.t('hub.firework'));
    setText(this.fx.label, ctx.i18n.t('hub.fx'));
    setText(shop.label, ctx.i18n.t('hub.shop'));
    this.el.append(this.stow.root, fire.root, this.fx.root, shop.root);
    this.update(0);
  }

  override update(_dt: number): void {
    const { sim, i18n } = this.ctx;
    const stowed = sim.getView().weaponStowed;
    setText(this.stow.label, i18n.t(stowed ? 'hub.unstow' : 'hub.stow'));
    toggleClass(this.stow.root, 'on', stowed);
    const fxOn = fxAnyVisible(sim.data.settings);
    toggleClass(this.fx.root, 'on', fxOn);
    this.fx.root.setAttribute('aria-pressed', String(fxOn));
    this.stow.root.setAttribute('aria-pressed', String(stowed));
  }
}
